/*
 * @author Tommy Brière
 * @copyright (c) 2016 Groupe PVP
 * @fileoverview Système de tabs,viewstack
 */
_w("PVPGEngine", PVPGEngine, "behavior", function($g, behavior) {
    "use strict";

    /*function Tabs() {

    }*/
    var Tabs={};

    Tabs.register = function(sel, openClass) {
        behavior.add(sel, function() {            
            var $me = $(this);
            var group = $me.attr("data-group");
            var href = $me.attr("href");
            var dpos = href.indexOf("#");
            var target = href.substr(dpos+1);
            var $target = $(target);
            var url = href.substr(0, dpos);
            $me.addClass(group);
            $me.on("click touchstart",function(e) {
                if(e.type == "click") { $(this).off("touchstart"); }
                var $group = $("."+group);
                $group.removeClass(openClass);
                $target.add($me).addClass(openClass);
                if (url&&url!==""&&window.history&&history.replaceState) {
                    history.replaceState(null, null, url);
                }
                return false;
            });
        });
    };
    Tabs.register(".action-tabs", "active");

    $g.Tabs = Tabs;

});
